import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Heart, Sparkles, X } from "lucide-react";
import { cn } from "@/lib/utils";

const FixedQuizCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const location = useLocation();

  // Don't show on quiz pages
  const isQuizPage = location.pathname.includes('/discovery/');

  useEffect(() => {
    if (isQuizPage || isDismissed) {
      setIsVisible(false);
      return;
    }

    const handleScroll = () => {
      const scrollY = window.scrollY;
      setIsVisible(scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isQuizPage, isDismissed]);

  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDismissed(true);
  };

  if (isQuizPage || isDismissed || !isVisible) return null;

  return (
    <div className={cn(
      "fixed bottom-20 left-4 right-4 md:left-auto md:right-6 md:w-80 z-40 transition-all duration-300",
      isVisible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
    )}>
      {/* Close button outside the overflow-hidden container */}
      <button
        onClick={handleClose}
        className="absolute -top-2 -right-2 w-8 h-8 bg-red-500 hover:bg-red-600 text-white rounded-full flex items-center justify-center shadow-lg z-50 transition-colors"
        aria-label="Close"
        data-testid="floating-quiz-close-btn"
        type="button"
      >
        <X size={18} strokeWidth={3} />
      </button>
      
      <div className="bg-primary rounded-2xl shadow-elevated p-4 relative overflow-hidden">
        <div className="absolute inset-0 mandala-bg opacity-20" />

        <div className="relative z-10">
          <p className="text-primary-foreground/80 text-xs mb-2">
            Discover your path to harmony
          </p>
          <h4 className="font-serif text-lg font-semibold text-primary-foreground mb-3">
            Take a Free Assessment
          </h4>
          
          <div className="flex flex-col gap-2">
            <Link
              to="/discovery/relationship-quiz"
              className="flex items-center gap-2 bg-accent/90 hover:bg-accent text-accent-foreground px-4 py-2 rounded-full text-sm font-medium transition-colors"
            >
              <Heart size={14} />
              Relationship Quiz
            </Link>
            <Link
              to="/discovery/life-quiz"
              className="flex items-center gap-2 bg-primary-foreground/10 hover:bg-primary-foreground/20 text-primary-foreground px-4 py-2 rounded-full text-sm font-medium transition-colors border border-primary-foreground/20"
            >
              <Sparkles size={14} />
              Life Transformation Quiz
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FixedQuizCTA;
